import { lazy, Suspense, type FC } from 'react';
import { Outlet } from 'react-router';
import { Container } from './style';

const ChatProvider = lazy(() => import('@components/Chat/ChatProvider'));
const Chat = lazy(() => import('@components/Chat'));

const InterviewerLayout: FC = () => {
  return (
    <Container>
      <Outlet />
      <Suspense fallback={null}>
        <ChatProvider>
          <Chat />
        </ChatProvider>
      </Suspense>
    </Container>
  );
};

export default InterviewerLayout;
